import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC, useEffect, useState} from 'react';
import {
  ButtonsWrapper,
  ModalContent,
  ModalWrapper,
  DeleteUsersEmailsWrapper,
} from './DeleteTestModal.styles';
import Button from '@atoms/Button';
import Text from '@atoms/Text';
import {IModule} from '@types';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '@store';
import {deleteModule} from '@store/slices/systems';

interface Props {
  isOpened: boolean;
  module?: IModule;
  onCloseRequest: () => void;
}

const DeleteSubsystemModal: FC<Props> = ({isOpened, onCloseRequest, module}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [moduleOnDelete, setModuleOnDelete] = useState<IModule | undefined>();

  useEffect(() => {
    if (module?.id) {
      setModuleOnDelete(module);
    }
  }, [module]);

  const DeleteModule = () => {
    if (moduleOnDelete?.id) {
      dispatch(deleteModule(moduleOnDelete.id));
    }
    onCloseRequest();
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader title={'Удалить модуль'} onClose={onCloseRequest} />
        <ModalContent>
          <DeleteUsersEmailsWrapper>
            <Text text={`Вы уверены, что хотите удалить модуль `} display="inline" />
            <Text text={`${moduleOnDelete?.name}`} type="bodyM" display="inline" />
            <Text text="?" display="inline" />
            <Text text="Это действие необратимо." />
          </DeleteUsersEmailsWrapper>
        </ModalContent>
        <ButtonsWrapper>
          <Button
            fullWidth
            title="Удалить"
            variant="filled"
            redButton
            onClick={DeleteModule}
          />
          <Button
            fullWidth
            title="Отменить"
            onClick={() => {
              onCloseRequest();
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default DeleteSubsystemModal;
